/* @flow */
import Glyph from 'components/Glyph';
import ModalMenuItem from 'components/ModalMenuItem';
import * as React from 'react';
import RequestTranscriptModal from 'organizations/components/RequestTranscriptModal';
import { formatNameForActionsMenuButton } from 'user/components/UserActionsMenuButton';

export type UserData = {
  id: Backbone$Id,
  name: string,
  first_name: string,
  last_name: string,
  can_get_message_history: boolean,
  can_request_message_history: boolean,
};

type Props = {
  isAdminView?: ?boolean,
  organization: {
    +id: Backbone$Id,
    +name: string,
  },
  user: UserData,
  disabled?: boolean,
  onGetTranscript?: (requested: boolean) => void,
};

class GetTranscriptMenuItem extends React.Component<Props> {
  requestTranscriptModal = () => {
    const { user, organization, isAdminView, onGetTranscript } = this.props;

    const users = [
      {
        id: user.id,
        fullName: formatNameForActionsMenuButton(user) || '',
        firstName: user.first_name,
        canGetMessageHistory: user.can_get_message_history,
        canRequestMessageHistory: user.can_request_message_history,
      },
    ];

    return (
      <RequestTranscriptModal
        users={users}
        organizationId={organization.id}
        organizationName={organization.name}
        forceRequestMessageHistory={!isAdminView}
        onGetTranscript={onGetTranscript}
      />
    );
  };

  render() {
    return (
      <ModalMenuItem
        modal={this.requestTranscriptModal()}
        disabled={this.props.disabled}
        {...this.props}>
        <Glyph name="email-transcript" />
        <span>{this.props.isAdminView ? 'Get message history' : 'Request message history'}</span>
      </ModalMenuItem>
    );
  }
}

export default GetTranscriptMenuItem;
